import React from 'react';
import './About.css';

export const About = () => {

	return(
		<main className='aboutContainer'>
			<h1 className='sectionTitle'>About</h1>
			<p>Drop the Needle began in Melbourne, Australia in the year 2020. Created by Damien Lewinski, this website shows the record labels he thinks everyone should listen to. </p>
		</main>
		)
}